import React from "react";

export default function Backdrop() {
    return <div class="loading">Loading&#8230;</div>;
}
